import React, { useState, useEffect } from 'react';
import { EnvelopeIcon } from '@heroicons/react/24/outline';
import discordLogo from '../assets/discord-logo-logodownload-download-logotipos-1-150x150.webp';
import { OurwareMark } from './FamilyMarks';
import { OURWARE_FOOTER_KICKER, OURWARE_NAME, OURWARE_URL } from '../lib/communityOs';

const Footer: React.FC = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  // Legacy deep links (?terms=true / ?privacy=true) redirect to standalone pages.
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('privacy') === 'true') {
      window.location.replace('/privacy');
    } else if (urlParams.get('terms') === 'true') {
      window.location.replace('/terms');
    }
  }, []);
  
  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) return;
    
    try {
      // Your actual Mailchimp form action URL
      const MAILCHIMP_URL = 'https://bornfree.us22.list-manage.com/subscribe/post?u=fbdd3f237d77a91fbc12b9cd5&id=5d6110184b&f_id=00dfc2e1f0';
      
      const formData = new FormData();
      formData.append('EMAIL', email);
      formData.append('b_fbdd3f237d77a91fbc12b9cd5_5d6110184b', ''); // honeypot field
      
      // Submit to Mailchimp
      const response = await fetch(MAILCHIMP_URL, {
        method: 'POST',
        body: formData,
        mode: 'no-cors' // Required for Mailchimp
      });
      
      // Since mode is 'no-cors', we can't check response status
      // So we assume success if no error is thrown
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 5000);
      
    } catch (error) {
      console.error('Subscription error:', error);
      // You might want to show an error message here
    }
  };
  
  return (
    <footer 
      className="text-white py-16 relative z-0"
      style={{
        backgroundImage: 'url(/images/fractals-4898844.webp)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-75"></div>
      <div className="container mx-auto px-6 relative z-10">
        {/* Top Section: Columns */}
        <div className="flex flex-col md:flex-row gap-12 mb-12">
          {/* Left Column: Links */}
          <div className="md:w-1/2 grid grid-cols-2 gap-8">
            <div>
              <h3 className="text-lg font-bold mb-4 border-b border-gray-700 pb-2" style={{ color: '#36a9f7' }}>Be Free</h3>
              <ul className="space-y-2">
                <li><a href="#home" className="text-gray-400 hover:text-white transition-colors">Home</a></li>
                <li><a href="#about" className="text-gray-400 hover:text-white transition-colors">About</a></li>
                <li><a href="#tech" className="text-gray-400 hover:text-white transition-colors">Tech</a></li>
                <li><a href="#faq" className="text-gray-400 hover:text-white transition-colors">FAQ</a></li>
                <li><a href="#community" className="text-gray-400 hover:text-white transition-colors">Community</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-bold mb-4 border-b border-gray-700 pb-2">Connect</h3>
              <ul className="space-y-2">
                <li>
                  <a href="https://discord.com/invite/nzU3VPgwpF" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors flex items-center">
                    <svg className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 24 24"><path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" /></svg>
                    Discord
                  </a>
                </li>
                <li>
                  <a href="https://x.com/BornFree432" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors flex items-center">
                     <svg className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 24 24"><path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"/></svg>
                    X
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/accounts/login/?next=https%3A%2F%2Fwww.instagram.com%2Fbornfree432%2F&is_from_rle" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors flex items-center">
                    <svg className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 24 24"><path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" /></svg>
                    Instagram
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/login/?next=https%3A%2F%2Fwww.facebook.com%2FBorn-Free-104725415022407" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors flex items-center">
                    <svg className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                    Facebook
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/channel/UCk-lbHIvAtwZSCcAzFPg-Bg" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors flex items-center">
                    <svg className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
                    YouTube
                  </a>
                </li>
              </ul>
            </div>
          </div>
          {/* Right Column: Newsletter */}
          <div className="md:w-1/2">
            <h3 className="text-lg font-bold mb-4 border-b border-gray-700 pb-2">Subscribe To Our Updates</h3>
            <p className="text-gray-400 mb-4">
              Occasional emails and no spam ever. Join our mailing list to receive the latest news and updates from our team.
            </p>
            <form onSubmit={handleSubscribe} className="flex flex-col space-y-3">
              <div className="flex">
                <div className="relative flex-grow">
                  <EnvelopeIcon className="h-5 w-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Your email address"
                    className="w-full py-2 pl-10 pr-3 bg-gray-800 border border-gray-700 rounded-l-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-white"
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-r-md transition-colors"
                >
                  SUBSCRIBE!
                </button>
              </div>
              {subscribed && (
                <div className="text-green-400 text-sm animate-fade-in">
                  You have successfully subscribed!
                </div>
              )}
            </form>
          </div>
        </div>

        {/* Discord Community Section */}
        <div className="flex flex-col items-center justify-center mb-8 pt-8 border-t border-gray-800">
          <a 
            href="https://discord.com/invite/nzU3VPgwpF"
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center text-gray-400 hover:text-white transition-colors"
          >
            <img src={discordLogo} alt="Discord" className="mb-2" style={{ width: '60px', height: '60px' }} />
            <span className="font-bold text-lg">
              JOIN THE COMMUNITY
            </span>
          </a>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-6 grid grid-cols-1 md:grid-cols-3 items-center gap-4 text-sm">
          <div className="text-gray-500 text-center md:text-left">
            &copy; {new Date().getFullYear()} BornFree. All rights reserved.
          </div>
          <a
            href={OURWARE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-ourware"
            className="justify-self-center flex flex-col items-center text-center text-gray-500 hover:text-gray-300 transition-colors"
          >
            <OurwareMark variant="footer" />
            <span className="mt-1 text-[10px] leading-tight">{OURWARE_FOOTER_KICKER}</span>
            <span className="text-base font-semibold leading-tight">{OURWARE_NAME}</span>
          </a>
          <div className="flex justify-center md:justify-end space-x-6">
            <a
              href="/terms"
              className="text-gray-500 hover:text-white transition-colors"
            >
              Terms of Service
            </a>
            <a
              href="/privacy"
              className="text-gray-500 hover:text-white transition-colors"
            >
              Privacy Policy
            </a>
            <a 
              href="/whitepaper.html" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-white transition-colors cursor-pointer"
            >
              Whitepaper
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
